"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetIdentity = exports.identify = void 0;
var constants_1 = require("../constants");
exports.identify = function (_a) {
    var _b;
    var session = _a.session;
    var id = session.userID;
    var props = (_b = {},
        _b[constants_1.EventProperty.CHANNEL] = session.channel,
        _b[constants_1.EventProperty.USER_ID] = id,
        _b[constants_1.EventProperty.SESSION_ID] = session.sessionID,
        _b);
    if (session.customer && session.customerCode) {
        var customerCodePropName = constants_1.EventProperty.CUSTOMER_CODE + "[" + session.customer + "]";
        props[customerCodePropName] = session.customerCode;
    }
    window.analytics.identify(id, props);
};
exports.resetIdentity = function () {
    window.analytics.reset();
};
